(function(ws) {
    'use strict';
    ws.models.updateCdChecks = Backbone.Model.extend({
        /**
         * Url
         */
        url: function() {
            return globals.path.api.orderentry.orderDetails.updateCdChecks.replace('{orderId}', this.get('orderId'));
        }
    });
})(westcon);
